document.addEventListener('DOMContentLoaded', () => {
    const dialogs = document.querySelectorAll('.wp-block-ahoy-modal');
    if (!dialogs.length) {
        return;
    }

    function getTriggerSelector(dialog) {
        const triggerClass = (dialog.dataset.triggerClass || 'js-open-modal').trim();
        if (!triggerClass) return null;
        return '.' + triggerClass.replace(/\s+/g, '.');
    }

    function getScopedRoot(clickTarget) {
        // Query Loop renders each post inside a wrapper; scope clicks to that wrapper first.
        return (
            clickTarget.closest('.wp-block-post') ||
            clickTarget.closest('article') ||
            clickTarget.closest('[data-post-id]') ||
            document
        );
    }

    function closeWithAnimation(dialog) {
        if (dialog.dataset.modalClosing === 'true') return;
        dialog.dataset.modalClosing = 'true';
        dialog.classList.add('is-closing');

        const onEnd = () => {
            dialog.removeEventListener('animationend', onEnd);
            dialog.classList.remove('is-closing');
            dialog.dataset.modalClosing = 'false';
            dialog.close();
        };

        dialog.addEventListener('animationend', onEnd, { once: true });
    }

    dialogs.forEach((dialog) => {
        if (!dialog.showModal || dialog.dataset.modalInitialized === 'true') return;
        dialog.dataset.modalInitialized = 'true';

        const closeOnBackdrop = dialog.dataset.closeOnBackdrop !== 'false';

        dialog.addEventListener('click', (e) => {
            if (closeOnBackdrop && e.target === dialog) {
                closeWithAnimation(dialog);
            }
        });

        dialog.addEventListener('cancel', (e) => {
            e.preventDefault();
            closeWithAnimation(dialog);
        });

        dialog.querySelectorAll('.wp-block-ahoy-modal-close').forEach((btn) => {
            btn.addEventListener('click', function () {
                const d = this.closest('dialog');
                if (d) {
                    closeWithAnimation(d);
                }
            });
        });
    });

    document.body.addEventListener('click', (e) => {
        const target = e.target;
        const scopeRoot = getScopedRoot(target);

        const scopedDialogs = scopeRoot === document
            ? [...dialogs]
            : [...scopeRoot.querySelectorAll('.wp-block-ahoy-modal')];

        const dialogToOpen =
            scopedDialogs.find((dialog) => {
                const selector = getTriggerSelector(dialog);
                return selector ? target.closest(selector) : false;
            }) ||
            // Fallback: if the click is outside the post scope, still allow global modals.
            [...dialogs].find((dialog) => {
                const selector = getTriggerSelector(dialog);
                return selector ? target.closest(selector) : false;
            });

        if (dialogToOpen?.showModal) {
            dialogToOpen.showModal();
            e.preventDefault();
        }
    });
});
